import {
  Cookie as CookieClient,
  createRealTimeCookie,
} from "@cookie-baker/browser";
import { atom } from "@reatom/framework";
import { reatomCookie } from "@reatom/npm-cookie-baker";

type authCookieModel = {
  accessToken?: string;
  refreshToken?: string;
  visitorId?: string;
};

const cookie = new CookieClient<authCookieModel>();
const realTimeCookie = createRealTimeCookie(cookie);

export const authAtom = reatomCookie(cookie, realTimeCookie);

export const isAuthedAtom = atom((ctx) => {
  const cookieObject = ctx.spy(authAtom.cookieAtom);
  return !!cookieObject.accessToken;
});
